import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { FilterParamsType } from '@/api/helpers/apiParamsHelpers';

export const getBillingReportApi = async (data: FilterParamsType): Promise<ApiResponseType<Blob>> => {
  const uri = '/opco/events/wire/export-report/';

  return authApiService.GET_XLS(uri, data);
};
